// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5995) return "static/css/5995.a18a973a.chunk.css";
	// return url for filenames based on template
	return "static/css/" + (chunkId === 8792 ? "main" : chunkId) + "." + {"108":"cb92becf","8792":"ce6ba18f"}[chunkId] + ".css";
};